import { Component } from '@angular/core';

@Component({
    selector: 'jhi-franceconnect-button',
    templateUrl: './franceConnect-button.component.html',
    styleUrls: ['./franceConnect-button.component.scss']
})
export class FranceConnectButtonComponent {

    openFranceConnectPopup() {
        window.open('/franceconnect/redirect', '_parent', 'resizable,scrollbars,status');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/franceConnect-button/franceConnect-button.component.ts